<div class="pop-up">
    <h1 mat-dialog-title style="text-align: center; color:blue;">NUEVO REPORTTABLE</h1>
    <div>
        <mat-form-field style="width: 80%;">
            <mat-label>Titulo</mat-label>
            <input matInput type="text " [(ngModel)]="rTable.titulo">
        </mat-form-field>
        <br>
        <mat-form-field style="width: 80%;">
            <mat-label>Consumo Titulo</mat-label>
            <input matInput type="text " [(ngModel)]="rTable.consumoTitulo">
        </mat-form-field>
        <br>
        <mat-form-field style="width: 80%;">
            <mat-label>ConsumoK</mat-label>
            <input matInput type="text " [(ngModel)]="rTable.consumoK">
        </mat-form-field>
        <br>
        <mat-form-field style="width: 80%;">
            <mat-label>Item Titulo</mat-label>
            <input matInput type="text " [(ngModel)]="rTable.itemTitulo">
        </mat-form-field>
        <br>
        <mat-form-field style="width: 80%;">
            <mat-label>ItemK</mat-label>
            <input matInput type="text " [(ngModel)]="rTable.itemK">
        </mat-form-field>
        <br>
        <mat-form-field style="width: 80%;">
            <mat-label>Ratio Titulo</mat-label>
            <input matInput type="text " [(ngModel)]="rTable.ratioTitulo">
        </mat-form-field>
        <br>
        <mat-form-field style="width: 80%;">
            <mat-label>Ratiomedio Titulo</mat-label>
            <input matInput type="text " [(ngModel)]="rTable.ratiomedioTitulo">
        </mat-form-field>
        <br>
    </div>
    <div>
        <button class="validar" mat-button mat-button [mat-dialog-close]="null">CARCELAR</button>
        <button class="validar" mat-button mat-button [mat-dialog-close]="rTable" cdkFocusInitial>OK</button>
    </div>
</div>